import React, { Component } from 'react';
import { Form, Card, Button, Col, Jumbotron, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';

class FormularioParametros extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Parametros",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            tipo: currentUserType,
            id: "",
            id_parametro: "",
            ID_EMPRESA: currentCompany,
            VALOR_SMLV: "",
            AUX_TRANSPORTE: "",
            CODIGO_CAJA_COMPENSACION: "",
            DESCRIPCION_CAJA_COMPENSACION: "",
            PORCENTAJE_CAJA: "",
            PORCENTAJE_SALUD: "",
            PORCENTAJE_PENSION: "",
            PORCENTAJE_CESANTIAS: "",
            CODIGO_ARL: "",
            DESCRIPCION_ARL: "",
            PORCENTAJE_ARL: "",
            tipo_usuario: "",
            buttonmsg: "",
            mensaje: "",
            O13: false,
            O15: false,
            O23: false,
            O47: false,
            R99: false
        }
    }

    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.ID_EMPRESA,
                'tipo': this.state.tipo,
            }
        }
        let titulo = "Crear Parametros";
        let id = "";
        fetch(config.servBackEnd + '/payrollparameters/' + this.state.ID_EMPRESA, datasend)
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.ok) {
                    let datos = data.data;
                    datos = datos[0]
                    const id_parametro = (datos.length > 0 ? datos[0]["ID_PARAMETRO"] : '');
                    if (id_parametro !== "") {
                        titulo = "Modificar Parametros";
                        id = id_parametro;
                        this.setState({
                            ID_EMPRESA: (datos[0]["ID_EMPRESA"]) ? datos[0]["ID_EMPRESA"] : "",
                            VALOR_SMLV: (datos[0]["VALOR_SMLV"]) ? datos[0]["VALOR_SMLV"] : "",
                            AUX_TRANSPORTE: (datos[0]["AUX_TRANSPORTE"]) ? datos[0]["AUX_TRANSPORTE"] : "",
                            CODIGO_CAJA_COMPENSACION: (datos[0]["CODIGO_CAJA_COMPENSACION"]) ? datos[0]["CODIGO_CAJA_COMPENSACION"] : "",
                            DESCRIPCION_CAJA_COMPENSACION: (datos[0]["DESCRIPCION_CAJA_COMPENSACION"]) ? datos[0]["DESCRIPCION_CAJA_COMPENSACION"] : "",
                            PORCENTAJE_CAJA: (datos[0]["PORCENTAJE_CAJA"]) ? datos[0]["PORCENTAJE_CAJA"] : "",
                            CODIGO_ARL: (datos[0]["CODIGO_ARL"]) ? datos[0]["CODIGO_ARL"] : "",
                            DESCRIPCION_ARL: (datos[0]["DESCRIPCION_ARL"]) ? datos[0]["DESCRIPCION_ARL"] : "",
                            PORCENTAJE_ARL: (datos[0]["PORCENTAJE_ARL"]) ? datos[0]["PORCENTAJE_ARL"] : "",
                            PORCENTAJE_SALUD: (datos[0]["PORCENTAJE_SALUD"]) ? datos[0]["PORCENTAJE_SALUD"] : "",
                            PORCENTAJE_PENSION: (datos[0]["PORCENTAJE_PENSION"]) ? datos[0]["PORCENTAJE_PENSION"] : "",
                            PORCENTAJE_CESANTIAS: (datos[0]["PORCENTAJE_CESANTIAS"]) ? datos[0]["PORCENTAJE_CESANTIAS"] : "",
                        })
                        ////console.log(data[0]['ID_USUARIO']);
                    }
                } else {
                    titulo = "Crear Parametros";
                    id = "";
                }
                this.setState({ titulo, id })
                ////console.log(data[0]['ID_USUARIO']);
            });
        //const { search } = this.props.location;

    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const {id} = this.state;
        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: this.state.ID_EMPRESA,
                VALOR_SMLV: this.state.VALOR_SMLV,
                AUX_TRANSPORTE: this.state.AUX_TRANSPORTE,
                CODIGO_CAJA_COMPENSACION: this.state.CODIGO_CAJA_COMPENSACION,
                DESCRIPCION_CAJA_COMPENSACION: this.state.DESCRIPCION_CAJA_COMPENSACION,
                PORCENTAJE_CAJA: this.state.PORCENTAJE_CAJA,
                CODIGO_ARL: this.state.CODIGO_ARL,
                DESCRIPCION_ARL: this.state.DESCRIPCION_ARL,
                PORCENTAJE_ARL: this.state.PORCENTAJE_ARL,
                PORCENTAJE_SALUD: this.state.PORCENTAJE_SALUD,
                PORCENTAJE_PENSION: this.state.PORCENTAJE_PENSION,
                PORCENTAJE_CESANTIAS: this.state.PORCENTAJE_CESANTIAS,
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.ID_EMPRESA
            }
        }

        if (id === "") {
            ruta = config.servBackEnd + '/payrollparameters/create';
        } else {
            ruta = config.servBackEnd + '/payrollparameters/modify/' + id;
        }
        //console.log(id);
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoId = (data.data.insertId !== 0) ? data.data.insertId : id;
                    this.setState({ id: nuevoId, mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_company: this.state.ID_EMPRESA })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Empresa con errores:" + errores[data.code] + " " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
        event.preventDefault();
    }

    validarRespo = (data) => {
        const newdata = data.split(";");
        let tmpO13 = false;
        let tmpO15 = false;
        let tmpO23 = false;
        let tmpO47 = false;
        let tmpR99 = false;
        newdata.forEach(element => {
            if (element === "O-13") tmpO13 = true;
            if (element === "O-15") tmpO15 = true;
            if (element === "O-23") tmpO23 = true;
            if (element === "O-47") tmpO47 = true;
            if (element === "R-99-PN") tmpR99 = true;
        });
        this.setState({
            O13: tmpO13,
            O15: tmpO15,
            O23: tmpO23,
            O47: tmpO47,
            R99: tmpR99
        })
    }
    CheckedRespo = ({ target }) => {
        let finalString = "";
        const { id } = target;
        const { checked } = target;
        const tmpResponsabilidad = this.state.RESPONSABILIDAD.split(";");
        const confirm = tmpResponsabilidad.findIndex(function (element) {
            return element === id;
        });
        if (checked) {
            if (confirm < 0) tmpResponsabilidad.push(id);
        } else {
            if (confirm >= 0) tmpResponsabilidad.splice(confirm, 1);
        }
        tmpResponsabilidad.forEach(element => {
            if (element !== "") finalString += element + ";";
        });
        finalString = finalString.substr(0, finalString.length - 1)
        this.validarRespo(finalString);
        this.setState({ RESPONSABILIDAD: finalString })
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeBoton = (this.state.id=== "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_clientes === "0") ? '¿Esta seguro que desea crear la empresa?' : '¿Esta seguro que desea modificar la empresa?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const rutaBack = (this.state.tipo === '0') ? '/empresa' : '/home';
        return (
            <div className="FormularioEmpresa">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Atras</Tooltip>}>
                            <div className="div-back">
                                <a href={rutaBack}>
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridEstado">
                                            <Form.Label>SALARIO MINIMO LEGAL VIGENTE (SMLV)</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ VALOR_SMLV: e.target.value })} value={this.state.VALOR_SMLV} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>VALOR AUXILIO DE TRANSPORTE</Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" onChange={e => this.setState({ AUX_TRANSPORTE: e.target.value })} value={this.state.AUX_TRANSPORTE} required />
                                            </InputGroup>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridDepartamento">
                                            <Form.Label>CAJA DE COMPENSACION</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_CAJA_COMPENSACION: e.target.value, DESCRIPCION_CAJA_COMPENSACION: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_CAJA_COMPENSACION} required>
                                                <option value="">--Seleccione Entidad--</option>
                                                <option value="1">GRUPO IDEAR</option>
                                                <option value="2">COMFANDI</option>
                                                <option value="3">COMFENALCO</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>PORCENTAJE CAJA DE COMPENSACION</Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" onChange={e => this.setState({ PORCENTAJE_CAJA: e.target.value })} value={this.state.PORCENTAJE_CAJA} required />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridDepartamento">
                                            <Form.Label>ARL</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_ARL: e.target.value, DESCRIPCION_ARL: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_ARL} required>
                                                <option value="">--Seleccione Entidad--</option>
                                                <option value="14-17">SEGUROS DE VIDA ALFA SA</option>
                                                <option value="14-18">LIBERTY SEGUROS DE VIDA</option>
                                                <option value="14-23">POSITIVA COMPAÑIA DE SEGUROS</option>
                                                <option value="14-25">RIESGOS PROFESIONALES COLMENA SA COMPAÑIA DE SEGUROS DE VIDA</option>
                                                <option value="14-28">ARP SURA</option>
                                                <option value="14-29">LA EQUIDAD SEGUROS DE VIDA ORGANISMO COOPERATIVO LA EQUIDAD VIDA</option>
                                                <option value="14-30">MAPFRE COLOMBIA VIDA SEGUROS SA</option>
                                                <option value="14-4">SEGUROS DE VIDA COLPATRIA SA</option>
                                                <option value="14-7">CIA DE SEGUROS BOLIVAR SA</option>
                                                <option value="14-8">COMPAÑIA DE SEGUROS DE VIDA AURORA</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>PORCENTAJE ARL</Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" onChange={e => this.setState({ PORCENTAJE_ARL: e.target.value })} value={this.state.PORCENTAJE_ARL} required />
                                            </InputGroup>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PORCENTAJE EPS</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ PORCENTAJE_SALUD: e.target.value })} value={this.state.PORCENTAJE_SALUD} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PORCENTAJE PENSION</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ PORCENTAJE_PENSION: e.target.value })} value={this.state.PORCENTAJE_PENSION} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>PORCENTAJE CESANTIAS</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ PORCENTAJE_CESANTIAS: e.target.value })} value={this.state.PORCENTAJE_CESANTIAS} required />
                                        </Form.Group>
                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioParametros);
//<-- disabled={!this.validateForm()} -->